export default function TrustSection() {
  const features = [
    { icon: "ri-shield-check-line", title: "Verified Links", desc: "Every spreadsheet entry is community-tested" },
    { icon: "ri-calendar-check-line", title: "Daily Updates", desc: "Fresh finds added every 24 hours" },
    { icon: "ri-team-line", title: "Community Picks", desc: "Curated by real shoppers worldwide" },
    { icon: "ri-search-eye-line", title: "Easy Browse", desc: "14 categories, one-click navigation" },
  ];

  const stats = [
    { value: "10K+", label: "Items Listed" },
    { value: "14", label: "Categories" },
    { value: "2", label: "Clicks to Buy" },
    { value: "24H", label: "Update Cycle" },
  ];

  return (
    <section className="py-16 md:py-24 bg-accent-50">
      <div className="px-6 md:px-10">
        <div className="mb-14">
          <span className="inline-flex items-center px-4 py-1.5 text-xs font-semibold rounded-full bg-white text-primary-700 whitespace-nowrap">
            Why Us
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-foreground-900 mt-4 leading-tight">
            Smart Shopping
            <br />
            Starts Here
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 mb-16">
          {features.map((f) => (
            <div key={f.title}>
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-3">
                <i className={`${f.icon} text-lg`}></i>
              </div>
              <h4 className="text-sm font-semibold text-foreground-900">{f.title}</h4>
              <p className="text-xs text-foreground-500 mt-1">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {stats.map((s) => (
            <div key={s.label}>
              <p className="font-display text-4xl md:text-5xl font-bold text-primary-700">{s.value}</p>
              <p className="text-sm text-foreground-500 mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}